import { useEffect, useState } from 'react';
import { api, ApiError } from './lib/api';
import type { Me } from './lib/types';
import { useRoute } from './lib/router';
import { Login } from './screens/Login';
import { Invite } from './screens/Invite';
import { Workspace } from './screens/Workspace';

export function App() {
  const route = useRoute();
  const [me, setMe] = useState<Me | null | undefined>(undefined);

  useEffect(() => {
    api
      .get<Me>('/v1/me')
      .then(setMe)
      .catch((e) => (e instanceof ApiError && e.status === 401 ? setMe(null) : setMe(null)));
  }, []);

  if (route.name === 'invite') return <Invite onDone={() => location.assign('/')} />;
  if (me === undefined)
    return (
      <div className="auth" aria-busy="true">
        <p className="hint">Yükleniyor…</p>
      </div>
    );
  if (me === null) return <Login onLogin={setMe} />;
  return <Workspace me={me} route={route} onLogout={() => setMe(null)} />;
}
